tinymce.addI18n('supportpal', {
    // General (multiple uses)
    "Save": Lang.get('general.save'),
    "Close": Lang.get('general.close'),
    "Cancel": Lang.get('general.cancel'),
    "General": Lang.get('general.general'),
    "Advanced": Lang.get('core.advanced'),

    // Formatting
    "Bold": Lang.get('core.bold'),
    "Underline": Lang.get('core.underline'),
    "Italic": Lang.get('core.italic'),
    "Strikethrough": Lang.get('core.strikethrough'),
    "Blockquote": Lang.get('core.quote'),
    "Insert\/Edit code sample": Lang.get('core.code'),
    "Clear formatting": Lang.get('core.clearformat'),

    // Colour related
    "Background color": Lang.get('core.background_colour'),
    "Background color {0}": Lang.get('core.background_colour'),
    "Text color": Lang.get('core.font_color'),
    "Text color {0}": Lang.get('core.font_color'),
    "Custom Color": Lang.get('core.custom_colour'),
    "Remove Color": Lang.get('core.remove_colour'),

    // Code
    "Code view": Lang.get('core.code'),

    // Lists
    "Bullet list": Lang.get('core.unorderedlist'),
    "Numbered list": Lang.get('core.orderedlist'),
    "Decrease indent": Lang.get('core.outdent'),
    "Increase indent": Lang.get('core.indent'),

    // Links
    "Insert\/edit link": Lang.get('core.insert_link'),
    "Url": Lang.get('general.url'),
    "Remove link": Lang.get('core.unlink'),
    "Link...": Lang.get('core.edit_link'),
    "Link": Lang.get('core.edit_link'),
    "Open link": Lang.get('core.open_link'),
    "Text to display": Lang.get('general.text'),
    "Open link in...": Lang.get('core.open_link_in'),
    "New window": Lang.get('core.new_window'),
    "Current window": Lang.get('core.current_window'),

    // Images
    "Image...": Lang.get('core.edit_image'),
    "Insert/edit image": Lang.get('core.insert_image'),
    "Source": Lang.get('general.url'),
    "Alternative description": Lang.get('core.alternative_description'),
    "Upload": Lang.get('core.upload'),
    "Browse for an image": Lang.get('core.browse_image'),
    "Drop an image here": Lang.get('core.drop_image'),

    // Tables
    "Table": Lang.get('core.table'),
    "Cell": Lang.get('core.cell'),
    "Cell properties": Lang.get('core.cell_properties'),
    "Merge cells": Lang.get('core.merge_cells'),
    "Split cell": Lang.get('core.split_cell'),
    "Row": Lang.get('core.row'),
    "Insert row before": Lang.get('core.inset_row_before'),
    "Insert row after": Lang.get('core.inset_row_after'),
    "Delete row": Lang.get('core.delete_row'),
    "Row properties": Lang.get('core.row_properties'),
    "Cut row": Lang.get('core.cut_row'),
    "Copy row": Lang.get('core.copy_row'),
    "Paste row before": Lang.get('core.paste_row_before'),
    "Paste row after": Lang.get('core.paste_row_after'),
    "Column": Lang.get('core.column'),
    "Insert column before": Lang.get('core.insert_column_before'),
    "Insert column after": Lang.get('core.insert_column_after'),
    "Delete column": Lang.get('core.delete_column'),
    "Cut column": Lang.get('core.cut_column'),
    "Copy column": Lang.get('core.copy_column'),
    "Paste column before": Lang.get('core.paste_column_before'),
    "Paste column after": Lang.get('core.paste_column_after'),
    "Table properties": Lang.get('core.table_properties'),
    "Delete table": Lang.get('core.delete_table'),
    "Width": Lang.get('core.width'),
    "Height": Lang.get('core.height'),
    "Cell spacing": Lang.get('core.cell_spacing'),
    "Cell padding": Lang.get('core.cell_padding'),
    "Border width": Lang.get('core.border_width'),
    "Caption": Lang.get('core.caption'),
    "Show Caption": Lang.get('core.show_caption'),
    "Alignment": Lang.get('core.alignment'),
    "Border style": Lang.get('core.border_style'),
    "Border color": Lang.get('core.border_colour'),
    "Cell type": Lang.get('core.cell_type'),
    "Scope": Lang.get('core.scope'),
    "Horizontal align": Lang.get('core.horizontal_align'),
    "Vertical align": Lang.get('core.vertical_align'),
    "Header cell": Lang.get('core.header_cell'),
    "Row group": Lang.get('core.row_group'),
    "Column group": Lang.get('core.column_group'),
    "Left": Lang.get('core.left'),
    "Center": Lang.get('core.center'),
    "Right": Lang.get('core.right'),
    "Top": Lang.get('core.top'),
    "Middle": Lang.get('core.middle'),
    "Bottom": Lang.get('core.bottom'),

    // Anchor
    "Anchor": Lang.get('core.anchor'),
    "ID": Lang.get('general.id'),
    "example": Lang.get('core.example'),

    "_dir": $('html').attr('dir') || 'ltr',
});
